/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_WritingInputs */

const en_read_along_ai_writing = /** @type {(inputs: Read_Along_Ai_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing your insights…`)
};

const es_read_along_ai_writing = /** @type {(inputs: Read_Along_Ai_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribiendo el análisis…`)
};

/**
* | output |
* | --- |
* | "Writing your insights…" |
*
* @param {Read_Along_Ai_WritingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_writing = /** @type {((inputs?: Read_Along_Ai_WritingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_WritingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_writing(inputs)
	return en_read_along_ai_writing(inputs)
});